"use client"

import { useEffect, useState } from "react";

import { GrayButton, IndigoButton } from "../../Atoms/Buttons/ColorButtons";
import JobAlertBox from "@/components/Molecules/JobAlertBox";
import Link from "next/link";
import RadioButton_2 from "@/components/Atoms/Buttons/RadioButton_2";


const AdminSideFilterBar = ({ callback, parentModule, organizationPreferences, lang, tags, parentComponent }) => {

  // PEOPLE FILTERS

  // dropdowns open close
  const [tagsDropdownOpen, setTagsDropdownOpen] = useState(false);
  const [communicationLanguagesDropdownOpen, setCommunicationLanguagesDropdownOpen] = useState(false);
  const [languagesDropdownOpen, setLanguagesDropdownOpen] = useState(false);
  // filtered
  const [communicationLanguagesFiltered, setCommunicationLanguagesFiltered] = useState(null);
  const [tagsFiltered, setTagsFiltered] = useState(null);
  const [filtered, setFiltered] = useState(null) // to modify according to element calling it (see line above)
  // show hide selects
  const [showTagSelect, setShowTagSelect] = useState(false);
  const [showCommunicationLanguagesSelect, setShowCommunicationLanguagesSelect] = useState(false);
  const [showBooleanSelect, setShowBooleanSelect] = useState(false);

  // TASKS FILTERS
  const [taskStatusDropdownOpen, setTaskStatusDropdownOpen] = useState(false);
  const [taskDateDropdownOpen, setTaskDateDropdownOpen] = useState(false);
  const [presetFilterQuery, setPresetFilterQuery] = useState(null)
  const [filterQuery, setFilterQuery] = useState(null)

  const [filteredTagId, setFilteredTagId] = useState(null)






  const toggleDropdown = (filterAttribute) => {
    console.log(filterAttribute);
    if (filterAttribute === "tags") {
      setTagsDropdownOpen(!tagsDropdownOpen);
    }
    if (filterAttribute === "languages") {
      setLanguagesDropdownOpen(!languagesDropdownOpen);
    }
    if (filterAttribute === "communication_languages") {
      setCommunicationLanguagesDropdownOpen(!communicationLanguagesDropdownOpen);
    }
    if (filterAttribute === "taskStatus") {
      setTaskStatusDropdownOpen(!taskStatusDropdownOpen);
    }
    if (filterAttribute === "taskDate") {
      setTaskDateDropdownOpen(!taskDateDropdownOpen);
    }
  };

  const closeDropdown = () => {
    setTagsDropdownOpen(false);
  };

  useEffect(() => {
    // Attach a click event listener to the document
    //  document.addEventListener("click", closeDropdown);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", closeDropdown);
    };
  }, []);

  const handleDropdownClick = (e) => {
    // Prevent the click on the dropdown itself from triggering the closeDropdown
    e.stopPropagation();
  };

  const handleToggleClick = (event, filterAttribute) => {
    event.stopPropagation();
    toggleDropdown(filterAttribute);
  };

  const handlePresetFilterClick = (event, presetFilterQuery ) => {
    event.stopPropagation();
    setPresetFilterQuery(presetFilterQuery)
    callback({ action: "filterApplied", presetFilterQuery: presetFilterQuery });
  }


  const handleChildCallback = (cb) => {
    // FilterSidebarDropdown
    console.log("CALLBACK@FILTERSIDEBAR", cb);

    if (cb.filtersApplied) {
      setFilterQuery(cb.filtersApplied)
    }

    if (cb.action === 'presetFilterApplied'){ 
      callback({ action: "filterApplied", presetFilterQuery: cb.presetFilterQuery });
    }

    if (cb.action === "filterParameter") {
      if (cb.attribute === 'tags') {
        setTagsFiltered({ ...tagsFiltered, parameter: cb.parameter });
        if (cb.parameter === "IS_EMPTY") {
          setShowBooleanSelect(true);
          setShowTagSelect(false);
        } else {
          setShowTagSelect(true);
          setShowBooleanSelect(false);
        }
      }
      else if (cb.attribute === 'communication_languages'){
        setCommunicationLanguagesFiltered({ ...communicationLanguagesFiltered, parameter: cb.parameter });
        setShowCommunicationLanguagesSelect(true)
      }
    }

    // FilterMultiSelect
    if (cb.action === "filterProperty") {
      console.log(cb);
      if (cb.attribute === 'tags') {
        setTagsFiltered({
        ...tagsFiltered,
        attribute: cb.attribute,
        properties: cb.properties,
        })
      }
      else if (cb.attribute === 'communication_languages') {
        setCommunicationLanguagesFiltered({
          ...communicationLanguagesFiltered,
          attribute: cb.attribute,
          properties: cb.properties,
          })
      }
    }

    if (cb.action === "filterBoolean") {
      setTagsFiltered({
        ...tagsFiltered,
        attribute: cb.attribute,
        booleanValue: cb.value,
      });
    }
    // console.log("FILTERED", filtered);
    // callback({action: 'filter', filterQuery: filtered})
  };


  const mergedFilters = () => {
    return {
      tagsFiltered: tagsFiltered,
      communicationLanguagesFiltered: communicationLanguagesFiltered
    }
  }



  return (
    // can get rid of div and leave aside
    <div>
      <aside
        id="sidebar"
        className="fixed top-0 left-20 z-10 w-60 h-screen transition-transform -translate-x-full border-r border-gray-200 sm:translate-x-0 dark:bg-gray-800 dark:border-gray-800 bg-white dark:bg-gray-900"
        aria-label="Sidebar"
      >


{parentComponent === 'JOBS' &&
       // PUBLICATION STATUS START 
        <RadioButton_2 caption1={'Published'} caption2={'Unpublished'} value1={'PUBLISHED'} value2={'UNPUBLISHED'} callbackObjectKey={'job_publication_status'} 
                callback={callback}
                />
        // PUBLICATION STATUS END 
}

{parentComponent === 'TALENT' &&
<>
       {/* // TALENT PUBLICATION STATUS   */}
        <RadioButton_2 caption1={'Published'} caption2={'Unpublished'} value1={'PUBLISHED'} value2={'UNPUBLISHED'} callbackObjectKey={'talent_publication_status'} 
                callback={callback}
                />
        {/* // TALENT PRIVACY  */}
        <RadioButton_2 caption1={'Public'} caption2={'Standard'} caption3={'Private'} value1={'PUBLIC'} value2={'STANDARD'} value3={'PRIVATE'} callbackObjectKey={'talent_access_level'} 
        callback={callback}
        />
        </>
}
        {/* TAGS START */}
                <ul className="">
                <Link href={parentComponent === 'TALENT' ? 'talent' : 'jobs'} onClick={()=>{setFilteredTagId(null)}}>
            <li className={`${!filteredTagId && 'border-l-8 border-indigo-600 bg-gray-200 dark:bg-gray-800'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-800 dark:text-gray-300 text-xs font-base duration-300`}>
            {parentComponent === 'TALENT' ? 'All Talents' : parentComponent === 'JOBS' ? 'All Jobs' : 'All / Tous'} 
  
            </li>
        </Link>
        {tags && tags.filter(tag=>tag.tag_type === 'PRIMARY').map(tag => 
         <Link key={tag.id} href={`?tagId=${tag.id}`} onClick={()=>{setFilteredTagId(tag.id)}}>
            <li className={`${filteredTagId === tag.id && 'border-l-8 border-indigo-600 bg-gray-200 dark:bg-gray-800'} mb-1 px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-800 dark:text-gray-300 text-xs font-base duration-300`}>
              {tag.tag_name}
            </li>
        </Link>
          )}
          </ul>
        {/* TAGS END */}
        <div className="px-4 pb-4 overflow-y-auto ">


    
        <div>
    {/* <div class="gp-container-title social-icons-bar">
     <img src="../assets/icons/bell2.svg" className="social-icons" style={{width:"20px"}}/>
     Create a Job Alert</div> */}
    <br/>

 {/* <JobAlertBox lang={lang}/> */}
  
  </div>


        </div>

        <div className="fixed bottom-6 ml-4 z-20 flex space-x-4 ml-14">
          {/* <IndigoButton
            caption={"Apply Filter(s)"} // this applies customFilter
            onClick={() => {
              console.log("filterQuery", filterQuery)
              callback({ action: "filtersApplied", filterQuery: filterQuery }); 
            }}
            fontSize={"xs"}
          /> */}

          <GrayButton
            caption={"Reset Filters"}
            fontSize={"xs"}
            onClick={() => {
              callback({filterReset: true});
              setFiltered(null);
              setShowTagSelect(null);
            }}
          />

        </div>
      </aside>


    </div>
  );
};

export default AdminSideFilterBar;